// Mock data for EKJ Nettoyage website

export const services = [
  {
    id: 1,
    title: "Nettoyage de Bureaux",
    description: "Entretien régulier de vos locaux professionnels pour un environnement de travail impeccable",
    icon: "Building2",
    features: ["Nettoyage quotidien", "Désinfection", "Entretien des sols", "Vitrerie"]
  },
  {
    id: 2,
    title: "Nettoyage de Campings",
    description: "Service complet d'entretien pour campings et hébergements de plein air",
    icon: "Tent",
    features: ["Sanitaires", "Mobil-homes", "Espaces communs", "Piscines"]
  },
  {
    id: 3,
    title: "Fin de Chantier",
    description: "Nettoyage approfondi après travaux pour une livraison impeccable",
    icon: "HardHat",
    features: ["Poussières", "Gravats", "Finitions", "Remise en état"]
  },
  {
    id: 4,
    title: "Nettoyage de Vitres",
    description: "Vitrerie professionnelle pour des surfaces transparentes et éclatantes",
    icon: "Square",
    features: ["Intérieur/Extérieur", "Hauteur", "Façades vitrées", "Vérandas"]
  },
  {
    id: 5,
    title: "Nettoyage de Moquettes",
    description: "Nettoyage en profondeur et traitement de vos revêtements textiles",
    icon: "Layers",
    features: ["Injection-extraction", "Détachage", "Désodorisation", "Protection"]
  },
  {
    id: 6,
    title: "Entretien Espaces Verts",
    description: "Maintenance et embellissement de vos extérieurs",
    icon: "Trees",
    features: ["Tonte", "Taille", "Débroussaillage", "Nettoyage"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Dupont",
    company: "Camping Les Pins",
    text: "Service impeccable ! EKJ Nettoyage assure l'entretien de notre camping depuis 2 ans. Professionnalisme et réactivité au rendez-vous.",
    rating: 5
  },
  {
    id: 2,
    name: "Jean-Pierre Martin",
    company: "Bureau d'Études Technique",
    text: "Excellente prestation pour le nettoyage de nos bureaux. L'équipe est discrète et efficace.",
    rating: 5
  },
  {
    id: 3,
    name: "Sophie Bernard",
    company: "Résidence Le Parc",
    text: "Nous faisons appel à EKJ pour le nettoyage de fin de chantier. Résultat toujours parfait, dans les délais.",
    rating: 5
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Professionnalisme",
    description: "Équipe formée et expérimentée",
    icon: "Award"
  },
  {
    id: 2,
    title: "Réactivité",
    description: "Intervention rapide sur demande",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Qualité garantie",
    description: "Matériel professionnel et produits adaptés",
    icon: "CheckCircle"
  },
  {
    id: 4,
    title: "Devis gratuit",
    description: "Estimation sans engagement",
    icon: "FileText"
  }
];

export const galleryImages = [
  {
    id: 1,
    title: "Espaces verts entretenus",
    category: "Espaces verts",
    image: "https://customer-assets.emergentagent.com/job_547aee01-8839-48d6-9fa7-736bae88c1ba/artifacts/olf3qutt_1000108337.jpg"
  },
  {
    id: 2,
    title: "Camping propre",
    category: "Camping",
    image: "https://customer-assets.emergentagent.com/job_547aee01-8839-48d6-9fa7-736bae88c1ba/artifacts/uwki0y44_1000108343.jpg"
  },
  {
    id: 3,
    title: "Sol carrelé impeccable",
    category: "Bureaux",
    image: "https://customer-assets.emergentagent.com/job_547aee01-8839-48d6-9fa7-736bae88c1ba/artifacts/kur184q2_1000106828.jpg"
  }
];

export const companyInfo = {
  name: "EKJ Nettoyage",
  phone: "07 75 78 72 88",
  siret: "482 975 703 00026",
  email: "contact@ekj-nettoyage.fr",
  address: "18 rue d'Auvergne",
  postalCode: "41300",
  city: "Salbris",
  fullAddress: "18 rue d'Auvergne, 41300 Salbris",
  description: "Spécialiste du nettoyage professionnel, nous intervenons pour l'entretien de vos bureaux, campings, chantiers et espaces verts."
};
